import { PlansTab } from "../../plans/UniversalPlansBox";

const NftApiPlansTab = () => {
  const nftApiServiceType =
    Number(import.meta.env.VITE_NFT_API_SERVICE_TYPE) || 8;
  return (
    <>
      <PlansTab serviceType={nftApiServiceType} />
    </>
  );
};

export default NftApiPlansTab;
